export const MEMBER_SESSION_STORAGE_KEY = 'jangi.memberSession'

export type MemberSession = {
  mCode: string
  userId: string
  orgName: string
  longtermCode: string
  bizGubun: string
  /** 사업자등록번호 */
  bizNum?: string
  /** 사업자등록증 파일 URL */
  bizCert?: string
  /** 환불 계좌 은행 */
  refundBank?: string
  /** 환불 계좌번호 */
  refundAccount?: string
  /** 환불 예금주 */
  refundHolder?: string
  bossName: string
  bossPhone: string
  bossEmail: string
  /** 기관 대표전화 (m_tell) */
  orgPhone?: string
  /** 기관 우편번호 (m_zipcode) */
  zipcode?: string
  /** 기관 주소 (m_addr) */
  address?: string
  /** 기관 상세주소 (m_addr_detail) */
  addressDetail?: string
  roleCode: string
  roleName: string
  signupSource: string
  emailVerified: boolean
  phoneVerified: boolean
  termsAgreed: boolean
  marketingAgreed: boolean
  discountPct?: number
  /** 카카오 연결이면 kakao. 아이디·비밀번호 로그인면 password */
  loginType?: 'kakao' | 'password'
  /** 카카오 연동 당시 이메일 */
  oauthEmail?: string
}

export function saveMemberSession(member: MemberSession) {
  sessionStorage.setItem(MEMBER_SESSION_STORAGE_KEY, JSON.stringify(member))
}

export function loadMemberSession(): MemberSession | null {
  const raw = sessionStorage.getItem(MEMBER_SESSION_STORAGE_KEY)
  if (!raw) {
    return null
  }

  try {
    const parsed = JSON.parse(raw) as MemberSession
    if (!parsed.mCode || !parsed.userId) {
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export function clearMemberSession() {
  sessionStorage.removeItem(MEMBER_SESSION_STORAGE_KEY)
}
